import React from "react";
import { SingletonHooksContainer } from 'react-singleton-hook';
import MainLayout from './containers/MainLayout';
import Queue from './pages/Queue';
import {Provider} from './store/index';
import './assets/scss/common/common.scss';

export default function App() {
	return (
		<Provider>
			<MainLayout>
				<Queue/>
				<SingletonHooksContainer/>
			</MainLayout>
		</Provider>
	);
}
